export class RecordType{
    static UNDEFINED = -1;
    static CONTROL_ESFINTER = 1;
    static BEHAVIOR = 2;
    static ACTION = 3;
    static EFA = 4;
    static EVENT = 5;
    static CUSTOM = 6;
}
